import workspaceQuery from '../../../graphql/queries/nominal/NominalNoteTypeWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/nominal/NominalNoteTypeListQuery.graphql';
import instanceQuery from '../../../graphql/queries/nominal/NominalNoteTypeQuery.graphql';
import defaultQuery from '../../../graphql/queries/nominal/NominalNoteTypeDefault.graphql';
import mutationQuery from '../../../graphql/mutations/nominal/NominalNoteTypeMutation.graphql';
import fragment from '../../../graphql/fragments/nominal/NominalNoteTypeFragment.graphql';
import { Direction } from '../../schema/p4types';

const NominalNoteType = {
  type: 'NominalNoteType',
  title: 'Nominal Note Types',
  formTitle: 'Nominal Note Type',
  formUrl: '/Nominal/NoteType/Details/',
  workspaceUrl: '/Nominal/NoteType/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'title',
    customVariables: () => {
      return {
        orderBy: 'title',
        orderDirection: Direction.Asc,
      };
    },
  },
  fragment,
  screenReference: 'NOMINAL_NOTE_TYPES',
};

export default NominalNoteType;
